







































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import PlaidService from '@/api/PlaidService';
import PlaidLink from '@/componentsV2/organisms/PlaidLink/PlaidLink.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    PlaidLink,
    FilledButton
  }
})
export default class PlaidButton extends Vue {
  @Prop(String) text?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: 'primary' }) colorSchema!: string;
  @Prop({ default: 'submit' }) type!: string;

  @Emit('click')
  click() {}

  plaidService = new PlaidService();
  linkToken: string | null = null;
  withdraw: boolean = false;

  async onPlaidSuccess(publicToken: string, plaidData: any) {
    const data = await this.plaidService.connect(
      publicToken,
      plaidData.account_id
    );

    if (data.status === 'linked') {
      this.linkToken = null;
      this.withdraw = true;
      this.$emit('click');
    }
  }

  get envPlaid() {
    return process.env.VUE_APP_ENV_PLAID;
  }

  async getLinkToken() {
    const { linkToken } = await this.plaidService.initilize();
    return linkToken;
  }

  async getPlaidLinkStatus() {
    const data = await this.plaidService.find();
    return data && data.status;
  }

  async initialize() {
    const status = await this.getPlaidLinkStatus();

    if (status === 'linked') {
      this.withdraw = true;
      return;
    }

    const linkToken = await this.getLinkToken();
    this.linkToken = linkToken;
  }

  mounted() {
    this.initialize();
  }
}
